export default {
  SET_CREDIT: "SET_CREDIT",
  SET_SOLICITATION: "SET_SOLICITATION",
  SET_OPTION_SELECTED: "SET_OPTION_SELECTED",
  SET_BENEFICIARIES: "SET_BENEFICIARIES",
  SET_STATE: "SET_STATE",
  SET_TAKER_IDENTIFICATION_TYPE: "SET_TAKER_IDENTIFICATION_TYPE",
  SET_TAKER_SELECTED_CITY: "SET_TAKER_SELECTED_CITY",
  SET_TAKER_SELECTED_STATE: "SET_TAKER_SELECTED_STATE",
  SET_TAKER_DATA: "SET_TAKER_DATA"
}
